import Spacer from "components/global/Spacer";
import connectInstagram from "assets/icons/connect_instagram.png";
import connectTiktok from "assets/icons/connect_tiktok.png";
import { BannerWrapper, ConnectInfo } from "./ManageChannelsStyles";
import ReactPlayer from "react-player";
import contactUs from "assets/icons/contact_us.svg";
import whatsAppIcon from "assets/icons/whatsap.svg";
import ControlledCheckBox from "components/global/ControlledCheckbox";
import { useState } from "react";
import FormGroupCustom from "components/global/FormGroupCustom";
import { axiosInstance } from "api";
import { showAlert } from "utils/utils";
import { CustomArrowSVG, LogoNew } from "assets/icons/FacebookConnect";
import { socialIcons } from "constants/post";
import instaVideo from "assets/videos/insta-video.mp4";
import tiktokVideo from "assets/videos/tiktok.mp4";
import { FacebookIcon, InstagramIcon } from "icons/PlatformIcon";
import WarningIconTriangle from "icons/WarningIconTriangle";
import useIsMobile from "hooks/useIsMobile";
import useIntercom from "hooks/useIntercom";

const guideObj = [
  {
    title: "Contact us via Chat support",
    icon: contactUs,
  },
  {
    title: "Chat us on WhatsApp",
    icon: whatsAppIcon,
    callback: () => window.location.replace("https://wa.link/postpaddy"),
  },
  // {
  //   title: "Contact us via Email support",
  //   icon: mailIcon,
  // },
  // {
  //   title: "Request a Call",
  //   icon: phoneIcon,
  //   callback: () => {
  //     document.querySelector(".RequestCall").classList.add("show");
  //     document.querySelector(".ConnectGuide").classList.remove("show");
  //   },
  // },
];

export const ConnectGuide = ({ disabled }) => {
  const { openSupportChat } = useIntercom({ autoBoot: false });

  return (
    <ConnectInfo isFacebook className="ConnectGuide flexColumn alignCenter">
      <div className="card">
        <img src={connectInstagram} alt="." className="image" />
        <Spacer y={2.4} />
        <header className="header">Connect Instagram business account</header>
        <Spacer y={2.4} />
        {/* <BannerWrapper bg="#E3EFFC" contentColor="#04326B">
          <InfoCircle color={"#04326B"} />
          <p className="content l3">
            Meta requires a Facebook account to connect Instagram to third-party
            platforms.
          </p>
        </BannerWrapper> */}
        <Spacer y={1.2} />
        <div className="flexColumn flexGap">
          <p>For support/ assistance:</p>
          {guideObj?.map((card, i) => (
            <a
              key={i}
              className={`guideItem ${i === 0 ? "support-tour" : ""}`}
              href={i === 2 ? "mailto:hello@postpaddy.com" : "##"}
              onClick={(e) => {
                if (i === 0) {
                  e.preventDefault();
                  openSupportChat();
                  return;
                }

                if (card.callback) {
                  e.preventDefault();
                  card.callback();
                }
              }}
            >
              <img src={card.icon} alt="icon" />
              <p>{card.title}</p>
            </a>
          ))}
        </div>
        <Spacer y={2.4} />
        <div className="flexRow justifySpaceBetween">
          <button
            className="btn cancel flexRow alignCenter justifyCenter"
            onClick={() =>
              document.querySelector(".ConnectGuide").classList.remove("show")
            }
          >
            Cancel
          </button>
          <Spacer x={2.4} />
          <button
            onClick={() => {
              document.querySelector(".ConnectGuide").classList.remove("show");
              document.querySelector(".ConnectChecklist").classList.add("show");
            }}
            className="btn actionBtn flexRow alignCenter justifyCenter"
            disabled={disabled}
          >
            Continue
          </button>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const ConnectGuideError = ({ show, setShow }) => {
  const { openSupportChat } = useIntercom({ autoBoot: false });

  return (
    <ConnectInfo
      isFacebook
      className={`ConnectGuideError flexColumn alignCenter ${show && "show"}`}
    >
      <div className="card">
        <img src={connectInstagram} alt="." className="image" />
        <Spacer y={2.4} />
        <header className="header">
          Failed to connect Instagram Business account
        </header>
        <Spacer y={1.2} />
        <p>
          It seems you were not able to connect your Instagram Business account.
          For support/assistance:
        </p>
        <Spacer y={2.4} />
        <div className="flexColumn flexGap">
          {guideObj?.map((card, i) => (
            <a
              key={i}
              className={`guideItem ${i === 0 ? "support-tour" : ""}`}
              href={i === 2 ? "mailto:hello@postpaddy.com" : "##"}
              onClick={(e) => {
                if (i === 0) {
                  e.preventDefault();
                  openSupportChat();
                  setShow(false);
                  return;
                }

                if (card.callback) {
                  e.preventDefault();
                  card.callback();
                  setShow(false);
                }
              }}
            >
              <img src={card.icon} alt="icon" />
              <p>{card.title}</p>
            </a>
          ))}
        </div>
        <Spacer y={2.4} />
        <div className="flexRow justifySpaceBetween">
          <button
            onClick={() => setShow(false)}
            className="btn spanFull actionBtn flexRow alignCenter justifyCenter"
          >
            Done
          </button>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const ConnectChecklist = ({ disabled, handleConnection }) => {
  const [checklist, updateChecklist] = useState({
    businessAccount: false,
    connectedToFb: false,
  });

  const handleCheckboxClick = (key) => {
    if (checklist?.[key]) {
      updateChecklist((prev) => ({ ...prev, [key]: false }));
    } else {
      updateChecklist((prev) => ({ ...prev, [key]: true }));
    }
  };

  return (
    <ConnectInfo isFacebook className="ConnectChecklist flexColumn alignCenter">
      <div className="card">
        <img src={connectInstagram} alt="." className="image" />
        <Spacer y={2.4} />
        <header className="header">
          To proceed, confirm you checked the list
        </header>
        <Spacer y={2.4} />
        <div className="flexColumn flexGap">
          <div className="guideItem">
            <ControlledCheckBox
              id="businessAccount"
              checked={checklist.businessAccount}
              onClick={() => handleCheckboxClick("businessAccount")}
            />
            <div>
              <p>My Instagram account is a business account</p>
              <label className="colorGrey8 l4">
                <span className="colorSecondary">
                  <a
                    href="https://postpaddy.com/pages/Product-training/how-to-convert-your-personal-instagram-account-to-a-business-account"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn how
                  </a>
                </span>{" "}
                to convert your personal to business account.
              </label>
            </div>
          </div>
          <div className="guideItem">
            <ControlledCheckBox
              id="connectedToFb"
              checked={checklist.connectedToFb}
              onClick={() => handleCheckboxClick("connectedToFb")}
            />
            <div>
              <p>My Instagram account is connected to my Facebook</p>
              <label className="colorGrey8 l4">
                <span className="colorSecondary cursorPointer">
                  <a
                    href="https://postpaddy.com/pages/Product-training/how-to-connect-your-social-media-accounts"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn more
                  </a>
                </span>{" "}
                to connect your account to Facebook.
              </label>
            </div>
          </div>
        </div>
        <Spacer y={2.4} />
        <div className="flexRow justifySpaceBetween">
          <button
            className="btn cancel flexRow alignCenter justifyCenter"
            onClick={() => {
              document
                .querySelector(".ConnectChecklist")
                .classList.remove("show");
              document.querySelector(".ConnectGuide").classList.add("show");
            }}
          >
            Go back
          </button>
          <Spacer x={2.4} />
          <button
            onClick={() => {
              document
                .querySelector(".ConnectChecklist")
                .classList.remove("show");
              handleConnection();
            }}
            className="btn actionBtn flexRow alignCenter justifyCenter"
            disabled={!checklist.businessAccount || !checklist.connectedToFb}
          >
            I am ready
          </button>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const RequestCall = () => {
  const [phoneNumber, setPhoneNumber] = useState();
  const [isSending, setIsSending] = useState(false);

  const handleRequestCall = async () => {
    setIsSending(true);
    const body = {
      phone_number: phoneNumber,
    };
    try {
      const res = await axiosInstance.post("request-call", body);
      if (res.data.status) {
        showAlert("Request sent");
        document.querySelector(".RequestCall").classList.remove("show");
      }
      setIsSending(false);
    } catch (error) {
      showAlert(error.message);
      setIsSending(false);
    }
  };

  return (
    <ConnectInfo isFacebook className="RequestCall flexColumn alignCenter">
      <div className="card">
        <header className="header">Request call</header>
        <Spacer y={1.2} />
        <p>Provide your phone number below and we will call you.</p>
        <Spacer y={2.4} />
        <FormGroupCustom
          fieldStyle="shortText"
          type="tel"
          label="Phone number"
          name="phone"
          placeholder="Phone number"
          className="spanFull"
          setValue={setPhoneNumber}
        />
        <Spacer y={2.4} />
        <div className="flexRow justifySpaceBetween">
          <button
            className="btn cancel flexRow alignCenter justifyCenter"
            onClick={() =>
              document.querySelector(".RequestCall").classList.remove("show")
            }
          >
            Cancel
          </button>
          <Spacer x={2.4} />
          <button
            onClick={handleRequestCall}
            className="btn actionBtn flexRow alignCenter justifyCenter"
            disabled={!phoneNumber || isSending}
          >
            Send request
          </button>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const InstagramAccountConvertInfo = ({ disabled, handleConnection }) => {
  const isMobile = useIsMobile(768);
  return (
    <ConnectInfo
      isInstagram
      className="InstagramConvertInfo flexColumn alignCenter"
    >
      <div className="card flexRow flexGap">
        <div className="igImage">
          <video
            src={instaVideo}
            style={{ borderRadius: "8px" }}
            width="320px"
            height="540px"
            autoPlay={isMobile ? false : true}
            loop
            muted
          />
        </div>
        <div className="flexCol justifySpaceBetween">
          <div>
            <div className="flexRow alignCenter iconContainer">
              <div className="iconWrapper">
                <LogoNew />
              </div>
              <CustomArrowSVG />
              <div className="iconWrapper">
                <img src={socialIcons.circle["instagram"]} alt="" />
              </div>
            </div>
            <Spacer y={2.4} />
            <header className="header">
              Connect Instagram business account
            </header>
            <Spacer y={1.2} />
            <p>
              To connect your Instagram Business Account to PostPaddy, you will
              need to log in with your Facebook account.
            </p>
            <Spacer y={1.2} />
            <p>
              Here’s how you can do it: First, ensure your Instagram profile is
              set as a Business profile. If it’s not, go to your Instagram app,
              navigate to your profile, tap the menu icon, and go to "Settings."
              From there, switch your account to a Business account under
              "Account" settings.
            </p>
            <Spacer y={1.2} />
            <p>
              Next, log in to your Facebook account. Ensure that you have
              administrative access to the Facebook Page you want to connect.
              Once you have the right permissions, you can link your Instagram
              account.
            </p>
          </div>
          <Spacer y={8.4} />
          <div className="flexRow justifySpaceBetween ">
            <button
              className="btn cancel flexRow alignCenter justifyCenter"
              onClick={() =>
                document
                  .querySelector(".InstagramConvertInfo")
                  .classList.remove("show")
              }
            >
              Cancel
            </button>
            <Spacer x={2.4} />
            <button
              onClick={() => {
                document
                  .querySelector(".InstagramConvertInfo")
                  .classList.remove("show");
                handleConnection();
              }}
              className="btn actionBtn flexRow alignCenter justifyCenter"
              disabled={disabled}
            >
              Go to Facebook
            </button>
          </div>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const ConnectInstagramToFacebook = ({ disabled, handleConnection }) => {
  return (
    <ConnectInfo
      isFacebook
      className="connectInstagramInfo flexColumn alignCenter"
    >
      <div className="card">
        <img src={connectInstagram} alt="." className="image" />
        <Spacer y={2.4} />
        <header className="header">Authenticate with Facebook</header>
        <Spacer y={1.2} />
        <p>
          To authorize PostPaddy, ensure your Instagram is linked to your
          Facebook page and you're an Admin.
        </p>
        <Spacer y={1.2} />
        <div>
          <ReactPlayer
            url="https://vimeo.com/882418259"
            controls={true}
            width={"100%"}
            style={{ background: "black" }}
            muted={true}
          />
        </div>
        <Spacer y={1.2} />
        <p className="colorBodyText">
          We’re sending you to Facebook for authorization. Keep in mind you may
          need to sign out and switch to the account you want to connect.
        </p>
        {/* <a href="##">Learn more</a> */}
        <Spacer y={2.4} />
        <div className="flexRow justifySpaceBetween">
          <button
            className="btn cancel flexRow alignCenter justifyCenter"
            onClick={() =>
              document
                .querySelector(".connectInstagramInfo")
                .classList.remove("show")
            }
          >
            Cancel
          </button>
          <Spacer x={2.4} />
          <button
            onClick={handleConnection}
            className="btn actionBtn flexRow alignCenter justifyCenter"
            disabled={disabled}
          >
            Go to Facebook
          </button>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const ConnectFacebookInfo = ({
  disabled,
  handleConnection,
  className = "",
}) => {
  return (
    <ConnectInfo
      isFacebook
      className={`connectFacebookInfo flexColumn alignCenter ${className}`}
    >
      <div className="card">
        <div className="flexRow alignCenter iconContainer">
          <div className="iconWrapper">
            <LogoNew />
          </div>
          <CustomArrowSVG />
          <div className="iconWrapper">
            <img src={socialIcons.circle["facebook"]} alt="" />
          </div>
        </div>

        <Spacer y={2.4} />
        <header className="header">
          Connecting PostPaddy to your Facebook page
        </header>
        <Spacer y={1.2} />
        <p className="colorBodyText">
          You need to grant PostPaddy permission to access and publish content
          to your Facebook page. This means we have to authenticate through
          Facebook.
        </p>
        <Spacer y={1.5} />
        <p className="colorBodyText">
          Keep in mind that to grant this permission, you must be an admin for
          your brand's Facebook page. You also may need to sign out and switch
          to the account you want to connect.
        </p>
        <Spacer y={7} />
        <div className="flexRow justifySpaceBetween">
          <button
            className="btn cancel flexRow alignCenter justifyCenter"
            onClick={() =>
              document
                .querySelector(".connectFacebookInfo")
                .classList.remove("show")
            }
          >
            Cancel
          </button>
          <Spacer x={2.4} />
          <button
            onClick={handleConnection}
            className="btn actionBtn flexRow alignCenter justifyCenter"
            disabled={disabled}
          >
            Go to Facebook
          </button>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const ConnectTiktokInfo = ({ disabled, handleConnection }) => {
  const isMobile = useIsMobile(768);
  return (
    <ConnectInfo
      isInstagram
      className="connectTiktokInfo flexColumn alignCenter"
    >
      <div className="card flexRow flexGap">
        <div className="igImage">
          <video
            src={tiktokVideo}
            style={{ borderRadius: "8px" }}
            width="320px"
            height="540px"
            autoPlay={isMobile ? false : true}
            loop
            muted
          />
        </div>
        <div>
          <img src={connectTiktok} alt="." className="image" />
          <Spacer y={2.4} />
          <header className="header">
            Connect your TikTok Business account to PostPaddy
          </header>
          <Spacer y={1.2} />
          <p className="l3 colorBodyText">
            To maximize PostPaddy's features, connect your TikTok business
            account. Follow the steps below to convert your personal account to
            a business account:
          </p>
          <Spacer y={0.6} />
          <ol className="list-items">
            <li>Log in to your TikTok account in the TikTok mobile app.</li>
            <li>Open your profile from the lower right-hand corner.</li>
            <li>Tap the three lines or dots in the upper right-hand corner.</li>
            <li>Go to Settings and Privacy, then select Account.</li>
            <li>Tap Switch to Business Account, followed by Next.</li>
            <li>Choose your business category and save your selection.</li>
          </ol>
          <Spacer y={2.4} />
          <div className="flexRow justifySpaceBetween">
            <button
              className="btn cancel flexRow alignCenter justifyCenter"
              onClick={() =>
                document
                  .querySelector(".connectTiktokInfo")
                  .classList.remove("show")
              }
            >
              Cancel
            </button>
            <Spacer x={2.4} />
            <button
              onClick={handleConnection}
              className="btn actionBtn flexRow alignCenter justifyCenter"
              disabled={disabled}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const ConnectToIgPrompt = ({ handleConnection, disabled }) => {
  const handleConnectWithFacebook = () => {
    document.querySelector(".ConnectToIgPrompt").classList.remove("show");
    document.querySelector(".InstagramConvertInfo").classList.add("show");
  };

  return (
    <ConnectInfo igPrompt className="ConnectToIgPrompt flexColumn alignCenter">
      <div className="card">
        <div className="flexRow alignCenter iconContainer">
          <div className="iconWrapper">
            <LogoNew />
          </div>
          <CustomArrowSVG />
          <div className="iconWrapper">
            <img src={socialIcons.circle["instagram"]} alt="" />
          </div>
        </div>
        <Spacer y={2.4} />
        <header className="header">
          Connect your Instagram Business /Creator Account
        </header>
        <Spacer y={1} />
        <p>
          Your Instagram account has to be a business account or creator account
        </p>
        <Spacer y={2.4} />
        <div className="flexColumn flexGap">
          <button
            className="btn flexRow alignCenter justifyCenter colorWhite fullWidth"
            style={{ background: "#0866FF", gap: "8px" }}
            onClick={handleConnectWithFacebook}
            disabled={disabled}
          >
            <FacebookIcon />
            Continue with Facebook
          </button>
          <button
            className="btn flexRow alignCenter justifyCenter colorWhite fullWidth"
            style={{ background: "#FE0077", gap: "8px" }}
            onClick={() => {
              document
                .querySelector(".ConnectToIgPrompt")
                .classList.remove("show");
              handleConnection();
            }}
            disabled={disabled}
          >
            <InstagramIcon />
            Continue with Instagram
          </button>
        </div>
        <Spacer y={3} />
        <div className="flexRow justifySpaceBetween">
          <button
            className="btn cancel flexRow alignCenter justifyCenter fullWidth"
            onClick={() => {
              document
                .querySelector(".ConnectToIgPrompt")
                .classList.remove("show");
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </ConnectInfo>
  );
};

export const IgUpgradePrompt = () => {
  return (
    <ConnectInfo
      igPrompt
      className="IgUpgradePrompt flexColumn alignCenter justifyCenter"
    >
      <div className="card">
        <header className="header">Upgrade Instagram connection</header>
        <Spacer y={1} />
        <p>Enable user tagging for your posts</p>
        <Spacer y={2.4} />
        <div className="flexColumn flexGap">
          <BannerWrapper bg="#FFFAE5" contentColor="#07070C">
            <WarningIconTriangle color={"#07070C"} size="20px" />
            <p className="content l3">
              To tag users in posts, you need to authenticate your Instagram
              Professional account through Facebook.
            </p>
          </BannerWrapper>
        </div>
        <Spacer y={2.4} />
        <div className="flexColumn flexGap">
          <div>
            <div className="semiBold">What you'll get:</div>
            <ul>
              <li>
                <p>Tag users in your scheduled posts</p>
              </li>
              <li>
                <p>Increase engagement with mentions</p>
              </li>
              <li>
                <p>Improve content discoverability</p>
              </li>
            </ul>
          </div>

          <p>
            This requires linking your Instagram Professional account to your
            Facebook account.
          </p>
        </div>
        <Spacer y={2.4} />
        <div className="flexRow justifySpaceBetween">
          <button
            className="btn cancel flexRow alignCenter justifyCenter"
            onClick={() =>
              document
                .querySelector(".IgUpgradePrompt")
                .classList.remove("show")
            }
          >
            Cancel
          </button>
          <Spacer x={2.4} />
          <button
            onClick={() => {
              document
                .querySelector(".IgUpgradePrompt")
                .classList.remove("show");
              document
                .querySelector(".InstagramConvertInfo")
                .classList.add("show");
            }}
            className="btn actionBtn flexRow alignCenter justifyCenter"
          >
            Connect with Facebook
          </button>
        </div>
      </div>
    </ConnectInfo>
  );
};
